import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class DeleteDressCodePictureErrorAction implements Action {
  public static readonly type = 'DeleteDressCodePictureErrorAction';

  constructor(public error: BijbError) {
  }

  public type = DeleteDressCodePictureErrorAction.type;
}
